/* Utils */
export function isVegaOS() {
  return navigator.userAgent.includes('Kepler') || navigator.userAgent.includes('AFT');
}

export function closeApp() {
  if (isVegaOS()) {
    window.ReactNativeWebView?.postMessage(
      JSON.stringify({ action: 'action-close-app' }),
    );
  }
  navigator.app.exitApp();
}

function getModelFireTV(nameModelUserAgent) {
  switch (nameModelUserAgent) {
    case 'AFTCA002': {
      return 'Fire TV Stick 4K Select 2025';
    }
    case 'AFTGAZL': {
      return 'Fire TV Cube 3rd Gen';
    }
    case 'AFTKA002': {
      return 'Fire TV 2-Series 2023';
    }
    case 'AFTKM': {
      return 'Fire TV Stick 4K 2nd Gen';
    }
    case 'AFTKRT': {
      return 'Fire TV Stick 4K Max 2nd Gen';
    }
    case 'AFTKA': {
      return 'Fire TV Stick 4K Max - 1st Gen';
    }
    case 'AFTTIFF43': {
      return 'Fire TV Omni Series';
    }
    case 'AFTTI43': {
      return 'Fire TV 4-Series';
    }
    case 'AFTWI001': {
      return '4K - Fire TV';
    }
    case 'AFTSSS': {
      return 'Fire TV Stick - 3rd Gen';
    }
    case 'AFTSS': {
      return 'Fire TV Stick Lite - 1st Gen';
    }
    case 'AFTT': {
      return 'Fire TV Stick - 2nd Gen';
    }
    case 'AFTR': {
      return 'Fire TV Cube - 2nd Gen';
    }
    case 'AFTA': {
      return 'Fire TV Cube - 1st Gen';
    }
    case 'AFTMM': {
      return 'Fire TV Stick 4K - 1st Gen';
    }
    case 'AFTRS': {
      return 'Element 4K - Fire TV';
    }
    case 'AFTN': {
      return 'Fire TV - 3rd Gen';
    }
    case 'AFTS': {
      return 'Fire TV - 2nd Gen ';
    }
    case 'AFTM': {
      return 'Fire TV Stick - 1st Gen';
    }
    case 'AFTB': {
      return 'Fire TV - 1st Gen';
    }
    default: {
      return nameModelUserAgent;
    }
  }
}

export function changeBackButtonActions() {
  window.addEventListener('load', () => {
    document.addEventListener('backbutton', (e) => {
      e.preventDefault();
      e.stopPropagation();
      document.dispatchEvent(new Event('customback'));
    }, false);
  });
}

export async function getDeviceInfo() {
  const [modelAFTName] = /aft+\S+/i.exec(navigator.userAgent);
  const [isVega] = /kepler/i.exec(navigator.userAgent);
  const [, vegaOSVersion] = /kepler ([^;])/i.exec(navigator.userAgent);

  return {
    os: isVega || '', // Kepler
    sdkVersion: vegaOSVersion, // Kepler 1.1
    screenWidth: window?.screen?.width || '',
    screenHeight: window?.screen?.height || '',
    modelName: modelAFTName ? getModelFireTV(modelAFTName) : '',
    modelAFTName,
  };
}
